import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageInfoModule } from '@src/app/modules/pages';

import { CustomPageComponent } from './custom-page.component';

@NgModule({
  declarations: [CustomPageComponent],
  imports: [CommonModule, PageInfoModule],
})
export class CustomPageModule {}
